import { useQuery } from 'react-query';

import { smartbiz } from '../ApiClient';
import { apiEndpoints } from '../constants/ApiConstants';
export const getStoreDetails = async (): Promise<any> => {
  try {
    const response = await smartbiz.get(`${apiEndpoints.storeDetails}`);
    return response;
  }
  catch(error) {
    return error;
  }
}

export const useGetStoreDetailsQuery = (isRefectchRequest?: boolean) => {
  const { isLoading, error, data, isError, refetch } = useQuery('storeDetails', getStoreDetails, {
    refetchOnWindowFocus: false,
    enabled: !isRefectchRequest
  });

  return { isLoading, error, data, isError, refetch };
}

export default useGetStoreDetailsQuery;
